export let filterLabels = [
  {
    label: '保险产品名称',
    type: 'input',
    value: 'type'
  },
  {
    label: '存储产品名称',
    type: 'input',
    value: 'productName'
  },
  {
    label: '监护人性别',
    type: 'select',
    value: 'guardianGender',
    clearable: true,
    options: [
      {
        label: '男',
        value: 'MALE'
      },
      {
        label: '女',
        value: 'FEMALE'
      }
    ]
  },
  {
    label: '被保人性别',
    type: 'select',
    value: 'insurerGender',
    clearable: true,
    options: [
      {
        label: '男',
        value: 'MALE'
      },
      {
        label: '女',
        value: 'FEMALE'
      }
    ]
  },
  {
    label: '提交时间',
    type: 'time-slot',
    value: 'createDate',
    clearable: true,
    startName: 'startDate', // 返回数据时，开始时间的字段名
    endName: 'endDate' // 返回数据时，结束时间的字段名
  }
]
export let insureInfoTableLabels = [
  {
    label: '合同编号',
    value: 'contractCode'
  },
  {
    label: '监护人姓名',
    value: 'guardianName'
  },
  {
    label: '性别',
    value: 'guardianGender'
  },
  {
    label: '身份证号',
    value: 'guardianIdentityCard'
  },
  {
    label: '被保人姓名',
    value: 'insurerName'
  },
  {
    label: '性别',
    value: 'insurerGender'
  },
  {
    label: '身份证号',
    value: 'insurerIdentityCard'
  }
]
